<template>
    <div class="container" style="margin-top: 90px;">
        <h4><b style="color: green;">ASSIGN EXTERNAL ASSESSOR</b></h4>
        <div class="mt-5 row">
            <div class="col-lg-4 col-sm-12 mb-4 d-flex justify-content-center" v-for="candidate in candidates">
                <div class="card" style="width: 20rem;" @click="set(candidate)">
                    <div class="card-body">
                        <h5 v-if="candidate.name" class="card-title">{{ candidate.name }}</h5>
                        <h6 v-if="candidate.fileNum" class="card-subtitle mb-2 text-body-secondary text-start">{{ candidate.fileNum }}</h6>
                        <div v-if="candidate.presentStatus == 'Senior Lecturer' && candidate.readerExternalAssessors.length <= 2" class="my-3 text-start">
                            <b>Add Assessor</b>
                            <span class="ms-2">
                                <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#assessorModal"><i class="fa fa-plus" aria-hidden="true"></i></button>
                            </span>
                        </div>
                        <div v-if="candidate.presentStatus == 'Reader' && candidate.profExternalAssessors.length <= 2" class="my-3 text-start">
                            <b>Add Assessor</b>
                            <span class="ms-2">
                                <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#assessorModal"><i class="fa fa-plus" aria-hidden="true"></i></button>
                            </span>
                        </div>
                        <div v-if="candidate.readerExternalAssessors.length == 0 && candidate.profExternalAssessors.length == 0" class="text-start">
                            This candidate hasn't been assigned assessors.
                        </div>
                        <p v-if="candidate.readerExternalAssessors.length > 0">
                            <b>External Assessors for Reader Rank</b>
                        </p>
                        <div v-for="assessor, assessorIndex in candidate.readerExternalAssessors">
                            <div class="text-start d-flex flex-row my-3">
                                <span class="me-3 mt-1"><i class="fa-solid fa-clipboard fa-xl" style="color: grey"></i></span>
                                <span>
                                    <div><b>{{ assessor.name }}</b></div>
                                    <div>{{ assessor.email }}</div>
                                </span>
                                <span class="ms-3 my-auto">
                                    <button @click="deleteExternal(candidate, assessor._id)" class="btn btn-outline-danger"><i class="fa-solid fa-xmark"></i></button>
                                </span>
                            </div>
                        </div>
                        <p v-if="candidate.profExternalAssessors.length > 0">
                            <b>External Assessors for Professor Rank</b>
                        </p>
                        <div v-for="assessor, assessorIndex in candidate.profExternalAssessors">
                            <div class="text-start d-flex flex-row my-3">
                                <span class="me-3 mt-1"><i class="fa-solid fa-clipboard fa-xl" style="color: grey"></i></span>
                                <span>
                                    <div><b>{{ assessor.name }}</b></div>
                                    <div>{{ assessor.email }}</div>
                                </span>
                                <span class="ms-3 my-auto">
                                    <button @click="deleteExternal(candidate, assessor._id)" class="btn btn-outline-danger"><i class="fa-solid fa-xmark"></i></button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="assessorModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="qualificationLabel">Assessor Details</h1>
                        <button id="close1" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start mx-3">
                        <div class="mb-3">
                            <div>
                                <label for="assessorName" class="form-label">Name:</label>
                                <input v-model="assessorName" type="text" class="form-control" id="assessorName">
                            </div>
                            <br>
                            <div>
                                <label for="assessorEmail" class="form-label">Email:</label>
                                <input v-model="assessorEmail" type="text" class="form-control" id="assessorEmail">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="assignExternal()" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="candidates.length == 0">
            <b>No candidates to assign external assessors</b>
        </div>
    </div>
</template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'assign',
    emits: ['toggleLoader'],
    data() {
        return {
            candidates: [],
            assessors: [],
            assessorName: '',
            assessorEmail: '',
            candidate: {}
        }
    },
    created(){
        this.getCandidates()
    },
    methods: {
        async getCandidates() {
            this.$emit('toggleLoader');

            const candidates = await DataService.getCandidates();

            if (candidates) {
                this.candidates = candidates
            }

            this.$emit('toggleLoader');
        },
        set(candidate){
            this.candidate = candidate
            this.assessorName = ''
            this.assessorEmail = ''
        },
        async assignExternal() {
            this.$emit('toggleLoader');

            var assessor = {
                candidateId: this.candidate._id,
                name: this.assessorName, 
                email: this.assessorEmail, 
                assessmentReceived: false
            }
            this.assessorName = ''
            this.assessorEmail = ''
            document.getElementById('close1').click();

            const res = await DataService.assignExternal(assessor);

            if (res) {
                alert('Assessor successfully assigned')
                this.getCandidates()
            }

            this.$emit('toggleLoader');
        },
        async deleteExternal(candidate, assessorId) {
            this.$emit('toggleLoader');

            const res = await DataService.deleteExternal(candidate._id, assessorId);

            if (res) {
                alert('Assessor successfully deleted')
                this.getCandidates()
            }

            this.$emit('toggleLoader');
        }
    }
}
</script>